import Api from '../Base'

class GetPOSAdvices extends Api {
  requestUrl = `/api/PointOfSaleAdvice`
}

export default GetPOSAdvices
